import React from "react";
import { FlightInfoRenderer } from "./typeRenderers/FlightInfoRenderer";
import { TaskInfoRenderer } from "./typeRenderers/TaskInfoRenderer";
import { HumanResourceInfoRenderer } from "./typeRenderers/HumanResourceInfoRenderer";
import { MissionEventInfoRenderer, MissionEventsInfoRenderer } from "./typeRenderers/MissionEventInfoRenderer";
import { MissionInfoRenderer } from "./typeRenderers/MissionInfoRenderer";
import { Divider } from "semantic-ui-react";
import _ from "lodash";
import { HumanResourceScheduleInfoRenderer } from "./typeRenderers/HumanResourceScheduleInfoRenderer";
import { FieldDescriptor, Utils } from "@crispico/foundation-react";
import StringFieldRenderer from "@crispico/foundation-react/entity_crud/fieldRenderers/StringFieldRenderer";
import DateFieldRenderer from "@crispico/foundation-react/entity_crud/fieldRenderers/DateFieldRenderer";
import { ProposedTimeSlotInfoRenderer } from "./typeRenderers/ProposedTimeSlotInfoRenderer";
import { missionEvent2EntityDescriptor, taskEntityDescriptor } from "AppEntityDescriptors";

export const options = FieldDescriptor.castAdditionalFieldRendererProps(StringFieldRenderer, { asLabel: false, showTooltip: true });
export const optionsAsLabel = FieldDescriptor.castAdditionalFieldRendererProps(StringFieldRenderer, { asLabel: true, showTooltip: true });
export const optionsForDate = FieldDescriptor.castAdditionalFieldRendererProps(DateFieldRenderer, { asLabel: false, showTooltip: true, format: Utils.dateTimeFormatShorter, formatForToday: Utils.timeFormat });

export class GanttInfoRenderer extends React.Component<{ entityName: string, entity: any }> {

    render() {
        const { entity, entityName } = this.props;
        if (!entity) {
            return null;
        }
        switch (entityName) {
            case "Flight":
                return <FlightInfoRenderer entity={entity} hideTitle />;
            case "Task":
                const { mission } = entity;
                return <div className="flex-container gap5 flex-wrap">
                    <TaskInfoRenderer entity={entity} hideTitle />
                    {/* <Divider fitted /> */}
                    <FlightInfoRenderer entity={entity.taskGroup} />
                    {/* <Divider fitted /> */}
                    <MissionInfoRenderer entity={mission} />
                </div>;
            case "HumanResourceSchedule":
                return <div className="flex-container-row gap5 flex-wrap">
                    <HumanResourceScheduleInfoRenderer entity={entity} hideTitle />
                    <HumanResourceInfoRenderer entity={entity.humanResource} />
                </div>;
            case "Mission2":
                const { events, tasks } = entity;
                const groupTaskByFlight: { [key: string]: any[] } = {};
                tasks && tasks.forEach((task: any) => {
                    if (!groupTaskByFlight[task.taskGroup.id]) {
                        groupTaskByFlight[task.taskGroup.id] = [];
                    }
                    groupTaskByFlight[task.taskGroup.id].push(task);
                });
                return <div className="flex-container gap3 flex-wrap">
                    <MissionInfoRenderer entity={entity} hideTitle />
                    <span className="small-margin-bottom">{taskEntityDescriptor.getLabel(tasks?.length > 1)}</span>
                    {Object.keys(groupTaskByFlight).map((flightId, index: number) => {
                        const tasks = groupTaskByFlight[flightId];
                        return <>
                            {index != 0 && <Divider fitted />}
                            <div className="flex-container-row gap5 flex-wrap">
                                {tasks.map((task: any, idx: number) => {
                                    return <>
                                        {idx == 0 && <FlightInfoRenderer entity={task.taskGroup} hideTitle />}
                                        <TaskInfoRenderer key={task.id} entity={task} hideTitle />
                                    </>
                                })}
                            </div>
                        </>
                    })}
                    {events?.length ? <Divider fitted /> : null}
                    {events?.length ? <span className="small-margin-bottom">{missionEvent2EntityDescriptor.getLabel(true)}</span> : null}
                    {events && <MissionEventsInfoRenderer entity={events} hideTitle />}
                </div>;
            case "MissionEvent2":
                return <MissionEventInfoRenderer entity={entity} hideTitle />;
            case "ProposedTimeSlot":
                return <ProposedTimeSlotInfoRenderer entity={entity} hideTitle />;
            default:
                return <></>;
        }
    }
}
